import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { OrganizationMetierApiService } from '@_services/api/organization-metier-api.service';
import { AppState } from '@_store/index.reducers';
import { GeneratedOrganizationMetierEffects } from './organization-metier-generated.effects';

@Injectable()
export class OrganizationMetierEffects extends GeneratedOrganizationMetierEffects {
  constructor(actions$: Actions, organizationMetierApiService: OrganizationMetierApiService, store$: Store<AppState>) {
    super(actions$, organizationMetierApiService, store$);
  }
}
